module.exports = __webpack_public_path__ + "step5_C2P_okuta_bridal.8c7bab60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_C2P_okuta_bridal.jpg
// module id = TQuq
// module chunks = 0